import { useState, useCallback } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { setOrganizationMembers } from '../../../store/slices/add-edit-policy.slice';

const useHttpGetMembersOMX = (organizationId: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);

    const fetchMembers = useCallback(() => {
        if (!organizationId) return;

        const { exec, abort } = userApi.getAllUsersFromOrganization({
            params: { organizationId },
            onSuccess: res => {
                dispatch(setOrganizationMembers(res.body));
            },
            onError: error => console.log(error),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    }, [organizationId, userApi]);

    return { exec: fetchMembers, isReady };
};

export default useHttpGetMembersOMX;
